import { gql } from '@apollo/client'
import PartialListing from 'graphql/fragments/PartialListing'
import PartialListingMap from 'graphql/fragments/PartialListingMap'

export default gql`
  query searchListings(
    $filters: ListingFilterInput
    $pagination: ListingSearchPagination
    $orderBy: [ListingSearchOrderBy]
    $isMap: Boolean = false
    $collection: String
    $condominium: String
  ) {
    searchListings(
      filters: $filters
      pagination: $pagination
      orderBy: $orderBy
      collection: $collection
      condominium: $condominium
    ) {
      from
      totalCount
      listings @skip(if: $isMap) {
        ...PartialListing
      }
      listings @include(if: $isMap) {
        ...PartialListingMap
      }
    }
  }
  ${PartialListing}
  ${PartialListingMap}
`
